import React from "react";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import * as reportApi from "../../api/reportApi";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { toast } from "react-toastify";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

class StatusReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      years: [],
      year: "",
      loading: false,
    };
  }

  async componentDidMount() {
    try {
      this.getYears();
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  getYears = async () => {
    const years = await reportApi.getYears();
    if (years) {
      years.sort((a, b) => b - a);
      this.setState({ years });
    }
  };

  handleChange = async (e) => {
    await this.setState({ year: e.target.value });
  };

  handledownload = async () => {
    const { year, loading } = this.state;

    if (loading) return;

    try {
      this.setState({ loading: true });

      const excelfile = await reportApi.getExcelFileCasesStatus(year, true);
      if (excelfile === false) {
        toast.error("Ingen data");
      }
    } catch (error) {
      console.error("Error downloading Case Status data:", error);
      toast.error("Noe gikk galt ved generering av rapporten");
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    return (
      <Container maxWidth="lg">
        <Backdrop
          open={this.state.loading}
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}
        >
          <div style={{ textAlign: "center" }}>
            <CircularProgress />
            <div style={{ marginTop: 16 }}>
              Nedlasting pågår, vennligst vent...
            </div>
          </div>
        </Backdrop>

        <main style={{ width: "80%", paddingTop: 100, margin: "auto" }}>
          <Paper style={{ width: "100%", padding: "20px" }}>
            <div style={{ height: 300 }}>
              <Grid container spacing={3} style={{ paddingTop: 100 }}>
                <Grid item lg={4} md={6} sm={12} xs={12}>
                  <h3>Status for saker innen valgt år:</h3>
                </Grid>
                <Grid item lg={4} md={6} sm={12} xs={12}>
                  <FormControl variant="standard" fullWidth>
                    <InputLabel>År</InputLabel>
                    <Select
                      name="year"
                      value={this.state.year || ""}
                      onChange={this.handleChange}
                    >
                      {this.state.years.map((year, index) => (
                        <MenuItem key={index} value={year}>
                          {year}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item lg={4} md={6} sm={12} xs={12}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    startIcon={<CloudDownloadIcon />}
                    onClick={this.handledownload}
                    disabled={this.state.loading || !this.state.year}
                    style={{ marginTop: 15, marginLeft: 50 }}
                  >
                    {this.state.loading ? "Henter..." : "Vis i Excel"}
                  </Button>
                </Grid>
              </Grid>
            </div>
          </Paper>
        </main>
      </Container>
    );
  }
}

export default StatusReport;
